/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const LocationPinFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g className="Location pin filled 16">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M8 15s6-2.91 6-8.182C14 3.605 11.313 1 8 1S2 3.605 2 6.818C2 12.091 8 15 8 15Zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        className="SVG"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const LocationPinFilledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'location-pin-filled-icon'}
      icon={LocationPinFilled}
      {...props}
      size={size}
    />
  );
};
